import * as React from 'react';

import { ListDetailStyles } from './ListDetailStyles';
import { DetailPanelProps } from './types';

export const DetailPanel: React.FC<DetailPanelProps> = ({
  children,
  leftMargin,
  testId = 'detail-panel',
  className,
}) => {
  const panelStyle: React.CSSProperties = {
    marginLeft: leftMargin,
  };

  return (
    <div
      data-tb-test-id={testId}
      className={`${ListDetailStyles.DetailPanel} ${className || ''}`}
      style={panelStyle}
    >
      <div className={ListDetailStyles.DetailContent}>
        {children}
      </div>
    </div>
  );
};

DetailPanel.displayName = 'DetailPanel';
